import { TIENDA_HANDY } from "config";

// Configuraciones de marca específicas (mantenidas para compatibilidad)
export const BRAND_CONFIGS = {
  handy: {
    title: "Handy - Dashboard Administración",
    description: "Comience a aumentar sus ventas con Handy.",
    favicon: "/handy-favicon-light.png",
    faviconDark: "/handy-favicon-dark.png",
    siteName: "handy.io",
    url: "https://handy.io/",
    ogImage: "https://handy.io/og-image/og-facebook.png",
    twitterImage: "https://handy.io/og-image/og-twitter.png",
    themeColor: "#2296f3",
    brandDescription: "Handy administración, la mejor forma de vender tus productos",
  },
  rhino: {
    title: "Rhino - Dashboard Administración",
    description: "Comience a aumentar sus ventas con Rhino.",
    favicon: "/favicon.png",
    faviconDark: "/favicon.png",
    siteName: "rhinox.io",
    url: "https://rhinox.io/",
    ogImage: "https://rhinox.io/og-image/og-facebook.png",
    twitterImage: "https://rhinox.io/og-image/og-twitter.png",
    themeColor: "#2296f3",
    brandDescription: "Rhino administración, la mejor forma de vender tus productos",
  },
};

/**
 * Obtiene la configuración de marca actual basada en TIENDA_HANDY (DEPRECATED)
 * @deprecated Usar useBranding() en su lugar
 * @returns {Object} Configuración de marca actual
 */
export const getCurrentBrandConfig = () => {
  console.warn("getCurrentBrandConfig is deprecated. Use useBranding() hook instead.");
  return TIENDA_HANDY ? BRAND_CONFIGS.handy : BRAND_CONFIGS.rhino;
};

/**
 * Obtiene el nombre de la marca actual (DEPRECATED)
 * @deprecated Usar useBranding().getBrandName() en su lugar
 * @returns {string} Nombre de la marca
 */
export const getBrandName = () => {
  console.warn("getBrandName is deprecated. Use useBranding().getBrandName() instead.");
  return TIENDA_HANDY ? "Handy" : "Rhino";
};

/**
 * Obtiene la URL base de la marca actual (DEPRECATED)
 * @deprecated Usar useBranding().getBrandUrl() en su lugar
 * @returns {string} URL base
 */
export const getBrandUrl = () => {
  console.warn("getBrandUrl is deprecated. Use useBranding().getBrandUrl() instead.");
  const config = getCurrentBrandConfig();
  return config.url;
};

/**
 * Obtiene el sitio web de la marca actual (DEPRECATED)
 * @deprecated Usar useBranding().getBrandSiteName() en su lugar
 * @returns {string} Nombre del sitio
 */
export const getBrandSiteName = () => {
  console.warn("getBrandSiteName is deprecated. Use useBranding().getBrandSiteName() instead.");
  const config = getCurrentBrandConfig();
  return config.siteName;
};

/**
 * Obtiene el favicon apropiado basado en el tema (DEPRECATED)
 * @deprecated Usar useBranding().getBrandResource('favicon') en su lugar
 * @param {boolean} isDarkMode - Si el tema actual es oscuro
 * @returns {string} URL del favicon
 */
export const getFaviconForTheme = (isDarkMode = false) => {
  console.warn('getFaviconForTheme is deprecated. Use useBranding().getBrandResource("favicon") instead.');
  const config = getCurrentBrandConfig();
  return isDarkMode && config.faviconDark ? config.faviconDark : config.favicon;
};

/**
 * Determina si se debe usar el estilo Handy basado en branding
 * @param {Object} branding - Configuración de branding desde useBranding()
 * @returns {boolean}
 */
export const shouldUseHandyStyle = (branding) => {
  // Si hay branding disponible, verificar el slug
  if (branding?.white_label?.slug) {
    return branding.white_label.slug === "handy";
  }

  // Fallback a la variable de entorno para compatibilidad
  return !!TIENDA_HANDY;
};

/**
 * Obtiene la configuración de tema basada en el branding actual
 * @param {Object} branding - Configuración de branding desde useBranding()
 * @returns {Object} Configuración de tema
 */
export const getThemeFromBranding = (branding) => {
  const isHandy = shouldUseHandyStyle(branding);

  const defaultConfig = {
    fontFamily: "'Poppins', sans-serif",
    borderRadius: 16,
    presetColor: "default",
    outlinedFilled: true,
    navType: "light",
    locale: "es",
    rtlLayout: false,
    container: false,
  };

  const handyConfig = {
    fontFamily: "'Poppins', sans-serif",
    borderRadius: 0,
    presetColor: "theme7",
    outlinedFilled: true,
    navType: "light",
    locale: "es",
    rtlLayout: false,
    container: false,
  };

  // Si el branding incluye configuración de tema personalizada
  if (branding?.branding?.theme) {
    const customTheme = branding.branding.theme;
    return {
      ...defaultConfig,
      fontFamily: customTheme.fontFamily || defaultConfig.fontFamily,
      borderRadius: customTheme.buttons?.radius !== undefined ? customTheme.buttons.radius : isHandy ? 0 : 16,
      presetColor: isHandy ? "theme7" : "default",
    };
  }

  return isHandy ? handyConfig : defaultConfig;
};

/**
 * Utilidad para obtener configuración de branding desde props o contexto
 * @param {Object} branding - Configuración de branding
 * @param {string} property - Propiedad a obtener
 * @param {*} fallback - Valor por defecto
 * @returns {*}
 */
export const getBrandingProperty = (branding, property, fallback = null) => {
  if (!branding?.branding) return fallback;

  const propertyMap = {
    primaryColor: "primary_color",
    secondaryColor: "secondary_color",
    logoUrl: "logo_url",
    faviconUrl: "favicon_url",
    brandName: () => branding.white_label?.name || "Rhino",
    brandSlug: () => branding.white_label?.slug || "rhino",
  };

  if (typeof propertyMap[property] === "function") {
    return propertyMap[property]();
  }

  const mappedProperty = propertyMap[property];
  return mappedProperty ? branding.branding[mappedProperty] : fallback;
};
